import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import { DashboardPanel, TranslatedText } from '../../shared/ui';

const Hero = styled(DashboardPanel)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  gap: theme.spacing(2.5),
  marginBottom: theme.spacing(3.5),
  padding: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}));

const HeroStack = styled(Stack)({
  width: '100%',
});

const HeroOverline = styled(TranslatedText)(({ theme }) => ({
  color: theme.vars!.palette.secondary.main,
  fontWeight: 700,
  letterSpacing: '0.14em',
}));

const HeroTitle = styled(TranslatedText)(({ theme }) => ({
  maxWidth: 760,
  marginTop: theme.spacing(1),
  color: theme.vars!.palette.surface.heroText,
  fontSize: '4.25rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '2.5rem',
  },
}));

const HeroTagline = styled(TranslatedText)(({ theme }) => ({
  maxWidth: 680,
  marginTop: theme.spacing(1.5),
  color: theme.vars!.palette.surface.heroText,
  fontSize: '2.25rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
  },
}));

const HeroDescription = styled(TranslatedText)(({ theme }) => ({
  maxWidth: 560,
  marginTop: theme.spacing(1.5),
  color: theme.vars!.palette.surface.heroMuted,
  fontSize: '1.125rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
  },
}));

export function AppHero() {
  const { pathname } = useLocation();

  if (pathname !== '/') {
    return null;
  }

  return (
    <Hero panelVariant="hero" component="section">
      <HeroStack spacing={2}>
        <div>
          <HeroOverline
            messageKey="app.subtitle"
            variant="overline"
          />
          <HeroTitle
            messageKey="app.title"
            variant="h1"
          />
          <HeroTagline
            messageKey="app.tagline"
            variant="h4"
          />
          <HeroDescription
            messageKey="app.shortDescription"
            variant="body1"
          />
        </div>
      </HeroStack>
    </Hero>
  );
}
